module.exports = __webpack_public_path__ + "static/media/roaming_hunger_la-37_fixed_v2.38b30d4f.jpg";